import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { useOrderDetails } from "../useOrderDetails";

export const CartNotes: FunctionComponent = () => {
  const { data } = useOrderDetails();

  const [language] = useLanguage();
  const { t } = useTranslation();

  const notes = data?.orderNotes[language];

  if (!notes) {
    return null;
  }

  return (
    <div className="border rounded-panel p-4">
      <h3 className="text-lg font-medium">{t("cart.notes")}</h3>
      <p className="text-sm">{notes}</p>
    </div>
  );
};
